import type { ProgramTypeKey } from './types';

// Shared design tokens for the Learning Lifecycle Dashboard.
// Hex values verified against the Figma design system (Dosen 3.0).

export const PROGRAM_TYPE_COLORS: Record<ProgramTypeKey, string> = {
  'role-excellence': '#F313BF', // pink — Figma exact
  development: '#009BF1', // blue — Figma exact
  standards: '#A012FF' // purple — Figma exact
};
